import { getCandidateDisplayWithCitySubtitle } from '../shared/candidate-display';
import {
  DogueFormDetails,
  OpenCallTypeUiConfig,
  OPEN_CALL_TYPE_IDS,
} from '../types';
import type { NavigationFilterDefinition } from '@repo/ui/helpers/navigation-filter-definitions';

const dogueFilterDefinitions: NavigationFilterDefinition[] = [
  {
    group: 'profile',
    key: 'cities',
    kind: 'multiSelect',
    label: 'CURRENT CITY',
    unit: 'city',
  },
];

export const dogueUiConfig: OpenCallTypeUiConfig = {
  typeId: OPEN_CALL_TYPE_IDS.Dogue,

  filters: {
    definitions: dogueFilterDefinitions,
    enabled: true,
  },

  candidateCard: {
    getDisplay: getCandidateDisplayWithCitySubtitle,
  },

  candidateList: {
    compact: true,
  },

  candidateDetails: {
    about: {
      getRows: (candidate) => {
        const formDetails = candidate.data
          .formDetails as DogueFormDetails | null;

        return [
          {
            label: 'City',
            value: candidate.profile.address?.city,
          },
          {
            label: 'Dog Name',
            value: formDetails?.dogDetails?.name,
          },
          {
            label: 'Dog Bio',
            value: formDetails?.dogDetails?.bio,
          },
        ];
      },
      title: 'Bio',
    },
    showContact: true,
    showBio: false,
    showAttributes: false,
    parseBioAsQa: false,
  },

  bulkActions: {
    contactExport: false,
    copilotExport: false,
    dismiss: true,
    moveStage: true,
  },
};
